var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8949 9.95502C14.8238 9.88361 14.7327 9.83538 14.6336 9.81664C14.5346 9.7979 14.4322 9.80954 14.3399 9.85002C13.2016 10.3463 11.9403 10.4883 10.7202 10.2573C9.50012 10.0263 8.37792 9.4331 7.49986 8.55505C6.62181 7.677 6.02863 6.5548 5.79765 5.33472C5.56666 4.11464 5.70857 2.85327 6.2049 1.71502C6.24596 1.62266 6.25806 1.52002 6.23961 1.42065C6.22117 1.32127 6.17303 1.22982 6.10156 1.15835C6.03009 1.08688 5.93864 1.03875 5.83927 1.0203C5.73989 1.00185 5.63726 1.01396 5.5449 1.05502C4.47529 1.52388 3.5363 2.24675 2.80946 3.16086C2.08262 4.07497 1.5899 5.15268 1.37407 6.30042C1.15825 7.44817 1.22585 8.63124 1.57101 9.74693C1.91617 10.8626 2.52845 11.8772 3.35468 12.7026C4.18092 13.5279 5.19614 14.1391 6.31219 14.4831C7.42824 14.8271 8.61139 14.8934 9.7589 14.6764C10.9064 14.4594 11.9836 13.9655 12.8969 13.2377C13.8103 12.5099 14.5322 11.5701 14.9999 10.5C15.0382 10.409 15.0486 10.3086 15.03 10.2116C15.0113 10.1146 14.9643 10.0253 14.8949 9.95502Z",
    fill: "#7A7B93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/MoonIcon.2886eedb2deb1508b6aa5167551e0cc5.svg";
export { ForwardRef as ReactComponent };